import React from 'react';
import PropTypes from 'prop-types';
import SurflineFooter from '@surfline/quiver-react/dist/SurflineFooter';
import entitlementsPropType from '@surfline/quiver-react/dist/PropTypes/entitlementsPropType';

const Footer = ({ entitlements, renderOptions }) => {
  if (renderOptions.hideNav === 'true') return null;
  return <SurflineFooter entitlements={entitlements ? entitlements.entitlements : []} />;
};

Footer.propTypes = {
  entitlements: PropTypes.shape({
    entitlements: entitlementsPropType,
  }),
  renderOptions: PropTypes.shape({
    hideNav: PropTypes.oneOf(['true', 'false']),
  }),
};

Footer.defaultProps = {
  renderOptions: {
    hideNav: 'false',
  },
};

Footer.defaultProps = { entitlements: [] };

export default Footer;
